// Messages
export const MESSAGES = "frontU/messages";

// Product
export const PRODUCTS = "frontU/products";